export const manifest = {
  screens: {
    scr_71pv5j: { name: "Home", route: "/", state: {"view":"main"}, position: {"x":160,"y":220} },
    scr_cqye3w: { name: "Chargen übertragen", route: "/", state: {"view":"transfer"}, position: {"x":1560,"y":220} },
    scr_hhcadc: { name: "Kammern", route: "/", state: {"view":"chambers"}, position: {"x":2960,"y":220} },
  },
  sections: {
    sec_3tavcb: { name: "Home & Main Views", x: 0, y: 0, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_3tavcb", children: [
      { kind: "screen", id: "scr_71pv5j" },
      { kind: "screen", id: "scr_cqye3w" },
      { kind: "screen", id: "scr_hhcadc" },
    ] },
  ],
}
